import React, { createContext } from 'react';

const ListContext = createContext({});

export { ListContext };